import { render, staticRenderFns } from "./SageList.vue?vue&type=template&id=23e1099a&scoped=true&"
import script from "./SageList.vue?vue&type=script&lang=js&"
export * from "./SageList.vue?vue&type=script&lang=js&"
import style0 from "./SageList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SageList.vue?vue&type=style&index=1&id=23e1099a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e1099a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/easy_dev/extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e1099a')) {
      api.createRecord('23e1099a', component.options)
    } else {
      api.reload('23e1099a', component.options)
    }
    module.hot.accept("./SageList.vue?vue&type=template&id=23e1099a&scoped=true&", function () {
      api.rerender('23e1099a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SageList.vue"
export default component.exports